import PageHandlersService from '@/utils/page-handlers-service';
import gsap from 'gsap';

const pageHandlers = new PageHandlersService();
const videoClickHandlers = new PageHandlersService();

const handleVideoClickClosure = (videoElement: HTMLVideoElement, playIconElement: HTMLButtonElement) => () => {
    if (videoElement.paused) {
        playIconElement.classList.add('nd-content__video-play-btn--hidden');
        videoElement.play();
    } else {
        playIconElement.classList.remove('nd-content__video-play-btn--hidden');
        videoElement.pause();
    }
};

const setPlayIconsOnVideos = (
    videoElements: HTMLVideoElement[],
    frameElements: HTMLIFrameElement[],
    contentContainer: Element,
    playIconElementExample: Element,
) => {
    const previousPlayIconElements = document.querySelectorAll('.js-nd-play-icon:not(.js-nd-play-icon-example)');

    previousPlayIconElements.forEach((element) => {
        element.remove();
    });

    videoElements.forEach((videoElement) => {
        videoElement.pause();

        const playIconElement = playIconElementExample.cloneNode(true) as HTMLButtonElement;
        playIconElement.classList.add('js-nd-play-icon');
        playIconElement.classList.remove('js-nd-play-icon-example');

        gsap.set(playIconElement, {
            top: videoElement.offsetTop + videoElement.clientHeight / 2,
        });

        contentContainer.appendChild(playIconElement);

        const handleVideoClick = handleVideoClickClosure(videoElement, playIconElement);

        videoClickHandlers.set(videoElement, handleVideoClick);
    });

    frameElements.forEach((frameElement) => {
        const youtubeVideoId = frameElement.src.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)?.pop();

        if (youtubeVideoId?.length === 11) {
            const imageElement = document.createElement('img');
            imageElement.src = `https://img.youtube.com/vi/${youtubeVideoId}/maxresdefault.jpg`;
            imageElement.classList.add('nd-play-preview');

            gsap.set(imageElement, {
                width: frameElement.clientWidth,
                height: frameElement.clientHeight,
                top: frameElement.offsetTop,
            });

            contentContainer.appendChild(imageElement);

            const playIconElement = playIconElementExample.cloneNode(true) as HTMLButtonElement;
            playIconElement.classList.add('js-nd-play-icon');
            playIconElement.classList.remove('js-nd-play-icon-example');

            gsap.set(playIconElement, {
                top: frameElement.offsetTop + frameElement.clientHeight / 2,
            });

            contentContainer.appendChild(playIconElement);

            const handleVideoClick = () => {
                gsap.set(playIconElement, { pointerEvents: 'none', opacity: 0 });
                gsap.set(imageElement, { pointerEvents: 'none', opacity: 0 });

                setTimeout(() => {
                    playIconElement.remove();
                    imageElement.remove();
                }, 400);
            };

            videoClickHandlers.set(imageElement, handleVideoClick);
        }
    });
};

const init = () => {
    const contentContainer = document.querySelector('.js-nd-content-container');
    const playIconElementExample = document.querySelector('.js-nd-play-icon-example');

    if (contentContainer && playIconElementExample) {
        const videoElements = Array.from(contentContainer.querySelectorAll('video'));
        const iframeElements = Array.from(contentContainer.querySelectorAll('iframe'));

        videoElements.forEach((videoElement) => {
            videoElement.pause();
        });

        setPlayIconsOnVideos(videoElements, iframeElements, contentContainer, playIconElementExample);

        const windowResizeHandler = () =>
            setPlayIconsOnVideos(videoElements, iframeElements, contentContainer, playIconElementExample);

        pageHandlers.set(window, windowResizeHandler, 'resize');
    }
};

const destroy = () => {
    videoClickHandlers.clear();
    pageHandlers.clear();
};

const _module = { init, destroy };

export default _module;
